import { ILang } from "../i18n";

const VI: ILang = {
  FilterDate: {
    Default: "Mặc định",
    Daily: "Theo ngày",
    Weekly: "Theo tuần",
    Monthly: "Theo tháng",
    ViewBy: "Hiển thị theo",
    ErrorSelectDateMessage:
      "Vui lòng chọn khoản thời gian ít nhất 3 ngày và cao nhất 15 ngày!"
  },
  Lang: {
    Code: "VN",
    TextEN: "Tiếng Anh",
    TextVN: "Tiếng Việt"
  },
  Login: {
    ErrorEmail: "Vui lòng nhập email!",

    LoginDescription: "Nhập email và mật khẩu của bạn để đăng nhập.",
    ButtonText: "Đăng nhập"
  },
  Sidebar: {
    Overview: "Tổng Quan",
    Manage: "Quản Lý",
    Account: "Tài Khoản",
    Dashboard: "Dashboard",
    ManageUser: "Quản Lý Người Dùng",
    ManageCashflow: "Quản Lý Dòng Tiền",
    RecordingBalance: "Bản Ghi Số Dư",
    AccountName: "Nhóm dòng Tiền",
    BankAccount: "Tài Khoản Ngân Hàng",
    ManageExchangeRate: "Quản Lý Tỉ Giá Hoán Đổi",
    Transaction: "Giao dịch",
    Setting: "Cài Đặt",
    Notification: "Thông Báo",
    FAQ: "Câu Hỏi Thường Gặp",
    Cashflow: "Dòng tiền",
    ManageAdminUser: "Manage Admin User",
    ManagePartnerUser: "Manage Partner User",
    Statistics: "Thống kê",
    AdminStatistics: "Admin Thống kê"
  },
  Modal: {
    CancelText: "Huỷ",
    SubmitText: "Xác nhận"
  },
  Setting: {
    AccountInformation: "Thông tin tài khoản",
    TimeRegister: "Tài khoản được đăng ký từ",
    ModalTitle: "Đổi mật khẩu",
    ModalOldPassword: "Mật khẩu cũ",
    ModalPassword: "Mật khẩu mới",
    ModalOldPasswordPlaceholder: "Nhập mật khẩu cũ",
    ModalPasswordPlaceholder: "Nhập mật khẩu mới",
    ModalConfirmPassword: "Xác nhận mật khẩu mới",
    UpdatePasswordSuccess: "Chỉnh sửa mật khẩu thành công",
    UpdateFail: "Chỉnh sửa mật khẩu không thành công!"
  },
  Role: {
    Owner: "Chủ sở hữu",
    Admin: "Quản trị viên",
    ViewReport: "Xem báo cáo"
  },
  Common: {
    UpdateSuccess: "Cập nhật thành công!",
    InsertNew: "Thêm mới",
    Edit: "Cập nhật",
    Update: "Cập nhật",
    Delete: "Xóa",
    Status: "Trạng thái",
    DateCreated: "Ngày tạo",
    RowPerPage: "Số dòng",
    Of: "của",
    More: "hơn",
    Code: "Code",
    Name: "Tên",
    NameValidate: "Vui lòng nhập tên!",
    Description: "Mô tả",
    Title: "Tiêu đề",
    Content: "Nội dung",
    DiscountPrice: "Giá giảm",
    Price: "Giá",
    Type: "Loại",
    Prominent: "Nổi bật",
    StartDate: "Ngày bắt đầu",
    EndDate: "Ngày kết thúc",
    Quantity: "Số lượng",
    Product: "Sản phẩm",
    Customer: "Người dùng",
    Detail: "Xem chi tiết",
    Cancel: "Huỷ",
    Confirm: "Xác nhận",
    Inflow: "Dòng thu",
    Outflow: "Dòng chi",
    Active: "Hoạt động",
    Deactive: "Không hoạt động",
    BankNumber: "Số tài khoản",
    Currency: "Đơn vị",
    ApiError: "Có lỗi! Vui lòng thử lại sau.",
    Amount: "Số tiền",
    AmountPlaceholder: "Nhập số tiền",
    Search: "Tìm kiếm",
    Role: "Phân quyền",
    Date: "Ngày",
    LastName: "Họ",
    FirstName: "Tên",
    Password: "Mật khẩu",
    Logout: "Đăng xuất tài khoản",
    PasswordValidate: "Vui lòng nhập mật khẩu!",
    PasswordOldValidate: "Vui lòng nhập mật khẩu hiện tại!",
    PasswordConfirmValidate: "Vui lòng nhập chính xác mật khẩu!",
    ResetPassword: "Đặt lại mật khẩu",
    UpdateCashflow: "Chỉnh sửa dòng tiền",
    AddMore: "Thêm mới",
    TimeDefault: "Thời gian mặc định",
    AllAccountBank: "Tất cả tài khoản ngân hàng",
    CompanyName: "Tên công ty",
    PhoneNumber: "Số điện thoại",
    EnterPhoneNumber: "Nhập số điện thoại",
    QuantityMember: "Số lượng nhân viên",
    Limit: "Giới hạn",
    PercentComplete: "Phần trăn hoàn thành",
    Close: "Đóng",
    Color: "Màu",
    ExpectedTime: "Thời gian dự kiến",
    Hour: "Giờ",
    Minute: "Phút",
    Processing: "Đang xử lý",
    SearchTasks: "Tìm kiếm công việc",
    SearchTaskAssignees: "Tìm kiếm người nhận nhiệm vụ",
    SearchByTime: "Tìm theo thời gian",
    All: "Tất cả",
    CreatedBy: "Tạo bởi",
    At: "Lúc",
    LastUpdated: "Cập nhật gần nhất",
    NotSet: "Chưa cập nhật",
    TotalTime: "Tổng thời gian",
    Used: "Đã sử dụng",
    UnexpectedError: "Xảy ra lỗi ngoài ý muốn",
    NoDescription: "Không có mô tả",
    CollapseDescription: "Thu gọn mô tả",
    ExpandDescription: "Mở rộng mô tả",
    UploadFile: "Tải lên tài liệu",
    TaskList: "Danh sách công việc",
    LoadMore: "Xem thêm",
    EnterContent: "Nhập nội dung",
    Send: "Gửi",
    Reply: "Trả lời",
    NoData: "Không có dữ liệu",
    Creator: "Người tạo",
    Day: "Ngày",
    LoadingMore: "Đang tải thêm",
    To: "Đến",
    Undefined: "Không xác định",
    Hello: "Xin chào",
    LoadingDataPleaseWait: "Đang tải dữ liệu, vui lòng chờ...",
    UserGuide: "Hướng dẫn sử dụng",
    ClearSearch: "Xoá tìm kiếm",
    SearchFoundResult: "Tìm thấy {{count}} kết quả",
    Today: "Hôm nay",
    Month: "Tháng",
    Week: "Tuần",
    List: "Danh sách",
    ListDay: "Ngày",
    From: "Từ"
  },
  Management: {
    Task: "Nhiệm vụ",
    ContentTask:
      "Quản lý, phân công và theo dõi tiến độ công việc giúp đội nhóm hoàn thành mục tiêu đúng hạn và hiệu quả.",
    Feature: "Tính năng",
    SomePopularFeatures: "Một số tính năng được yêu thích",
    InternalAnnouncements: "Thông báo nội bộ",
    ContentInternalAnnouncements:
      "Cập nhật nhanh mọi thông tin, giúp nhân viên nắm bắt kịp thời và kết nối hiệu quả trong doanh nghiệp.",
    CompanyRules: "Nội quy công ty",
    ContentCompanyRules:
      "Giúp nhân viên nắm rõ quy định, chuẩn mực và văn hóa làm việc thống nhất trong toàn doanh nghiệp.",
    MeetingSchedule: "Lịch họp",
    ContentMeetingSchedule:
      "Quản lý, sắp xếp và theo dõi các cuộc họp nội bộ, giúp đội nhóm phối hợp hiệu quả và đúng thời gian.",
    LeaveManagement: "Quản lý nghỉ phép",
    ContentLeaveManagement:
      "Đơn giản hóa quy trình xin nghỉ, phê duyệt và theo dõi ngày phép minh bạch, thuận tiện cho mọi nhân viên.",
    ContentLinkCoDrive:
      "Lưu trữ, chia sẻ và quản lý tài liệu doanh nghiệp an toàn, tập trung và dễ dàng truy cập mọi lúc.",
    ContentGoogleAds:
      "Quản lý, theo dõi và tối ưu chiến dịch quảng cáo Google thông minh ngay trên cùng một nền tảng",
    ContentGoogleConsole:
      "Công cụ quản trị website giúp giám sát, phân tích và cải thiện SEO dễ dàng trên nền tảng Google.",
    GoogleToolContent:
      "Dự án tích hợp hai công cụ phân tích và quản lý hiệu suất digital marketing chính của Google, bao gồm Google Ads API (quản lý quảng cáo trả phí) và Google Search Console API (giám sát hiệu suất tìm kiếm tự nhiên)",
    CustomerSupport: "Hỗ trợ giải đáp",
    ContentCustomerSupport: "Hỗ trợ giải đáp thông tin cho người dùng.",
    Workflow: "Quy trình",
    AvailableWorkflows: "Khả dụng",
    ClosedWorkflow: "Quy trình đã đóng",
    WorkflowCreatedbyMe: "Tạo bởi tôi",
    WorkflowManagement: "Quản lí quy trình",
    CreateNewWorkflow: "Tạo mới workflow",
    UpdateWorkflow: "Cập nhật luồng công việc",
    DuplicateWorkflow: "Nhân bản luồng công việc",
    DuplicateNewWorkflow: "Nhân bản thành luồng công việc mới",
    NewWorkflowName: "Tên luồng công việc mới",
    ExportToExcel: "Xuất file Excel",
    CloseWorkflow: "Đóng luồng công việc",
    WorkflowName: "Tên luồng công việc",
    Stage: "Giai đoạn",
    StageName: "Tên giai đoạn",
    WorkflowCategory: "Phân loại luồng công việc",
    WorkflowAdministrators: "Thành viên quản trị quy trình",
    ContentWorkflowAdministrators:
      "Người quản trị có thể xem nhiệm vụ của mọi thành viên. Bạn được mặc định là người quản trị",
    GroupCreateTask: "Nhóm Thành viên có quyền tạo các nhiệm vụ mới.",
    ContentGroupCreateTask:
      "Các thành viên hoặc nhóm thành viên có quyền tạo nhiệm vụ trong luồng công việc.",
    PlacehoderGroupCreateTask: "Viết tên thành viên hoặc phòng ban",
    WorkflowSupervisor: "Người giám sát workflow",
    ContentWorkflowSupervisor:
      "Thành viên có quyền xem & review tất cả nhiệm vụ nhưng không có quyền chỉnh sửa",
    AutomaticallyForwardTaskWhenReachingThisStage:
      "Chuyển tiếp công việc khi đến giai đoạn",
    WhenReachingTheSelectedStageTheTaskWillAutomaticallyMoveToAnotherWorkflow:
      "Công việc ở giai đoạn được chọn sẽ chuyển đến luồng công việc khác",
    NoStagesAvailable: "Không có giai đoạn nào",
    SelectWorkflow: "Chọn luồng công việc",
    SelectTransitionStage: "Chọn giai đoạn chuyển tiếp",
    OtherOptions: "Các tùy chọn khác",
    MemberGroupsWithPermissionToWiewTheWorkflow:
      "Nhóm thành viên có thể xem được workflow",
    MembersOrMemberGroupsWhoCanSeeTheWorkflowInTheList:
      "Các thành viên hoặc nhóm thành viên có thể nhìn thấy luồng công việc trong danh sách",
    WorkflowUserGuide: "Hướng dẫn làm việc với quy trình",
    DetailedDescriptionOfTheWorkflow: "Mô tả chi tiết về luồng công việc",
    DetailedWorkflowDescription: "Mô tả chi tiết về luồng công việc",
    ReasonForTaskFailure: "Lý do thất bại",
    PleaseProvideDetailedPossibleReasonsForTaskFailureIfAny:
      "Vui lòng ghi chi tiết các lí do thất bại có thể xảy ra, nếu có",
    EnterAPossibleReasonForFailure: "Điền một lý do thất bại có thể có",
    PleaseEnterTheWorkflowName: "Vui lòng nhập tên luồng công việc",
    PleaseSelectTheWorkflowCategory: "Vui lòng chọn phân loại luồng công việc",
    PleaseEnterTheWorkflowCategoryName:
      "Vui lòng nhập tên phân loại luồng công việc",
    PleaseSelectAWorkflow: "Vui lòng chọn luồng công việc",
    PleaseSelectATransitionStage: "Vui lòng chọn giai đoạn chuyển tiếp",
    CreateTask: "Tạo nhiệm vụ",
    CreateContract: "Tạo hợp đồng",
    CreateWorkflow: "Tạo giai đoạn",
    AddStage: "Thêm giai đoạn",
    AddNewStage: "Thêm giai đoạn mới",
    EditStage: "Chỉnh sửa giai đoạn",
    PleaseEnterTheTaskName: "Vui lòng nhập tên nhiệm vụ",
    InvalidTime: "Invalid time",
    EditTask: "Chỉnh sửa nhiệm vụ",
    UpdatePersonalDeadlines: "Cập nhật deadline cá nhân",
    PersonalDeadlines: "Deadline cá nhân",
    EditContract: "Chỉnh sửa hợp đồng",
    TaskName: "Tên nhiệm vụ",
    ContractName: "Tên hợp đồng",
    AssignTaskTo: "Giao nhiệm vụ cho",
    ContractExecutor: "Người thực hiện hợp đồng",
    EnterMemberName: "Nhập tên thành viên nhận nhiệm vụ",
    TaskDescription: "Mô tả nhiệm vụ",
    ContractDescription: "Mô tả hợp đồng",
    ShortTaskDescription: "Mô tả ngắn về nhiệm vụ",
    ShortContractDescription: "Mô tả ngắn về hợp đồng",
    Follower: "Người theo dõi",
    TaskFollower: "Người theo dõi công việc",
    EditFollowers: "Chỉnh sửa người theo dõi",
    ExpectedCompletionDate: "Ngày dự kiến hoàn thành",
    ClickToSelectADate: "Nhấn để chọn ngày",
    ClickToSelectATime: "Nhấn để chọn giờ",
    Deadline: "Thời hạn",
    NoDeadline: "Không thời hạn",
    Expectation: "Kỳ vọng",
    Actual: "Thực tế",
    Attachments: "Tài liệu đính kèm",
    AttachUpTo10Files: "Đính kèm tối đa 10 tài liệu",
    DragFilesHere: "Kéo tệp vào đây",
    OrSelectFilesFromYourComputer: "Hoặc chọn file từ máy tính của bạn",
    NumberOfFilesExceeded:
      "Bạn đang upload quá số lượng file cho phép, số lượng file vượt quá:",
    MaximumFileUpload: "Bạn đã upload file vượt quá dung lượng (tối đa 15MB)",
    InvalidFileFormat: "Bạn đã upload file sai định dạng",
    StageAdministrator: "Người quản trị giai đoạn",
    DefaultFollowersOfTheStage: "Người theo dõi mặc định của giai đoạn",
    StageAssignee: "Người thực thi giai đoạn",
    HowIsTheTaskAssignedOrReassigned:
      "Công việc được giao/giao lại như thế nào?",
    StageCompletionGuide: "Hướng dẫn hoàn thành các giai đoạn trong nhiệm vụ",
    StageCompletionInstructions: "Giải thích cách hoàn thành giai đoạn",

    RetainPreviousAssignee: "Giữ nguyên người nhận việc ở giai đoạn trước",
    ReturnToFirstAssignee: "Giao về cho người nhận nhiệm vụ đầu tiên",
    UnassignedStageManagerDecides:
      "Không giao cho ai - Để người quản lí giai đoạn quyết định",
    DecisionByStageMover: "Để người chuyển giai đoạn quyết định",
    RandomlyAssign: "Chọn 1 người ngẫu nhiên nhận nhiệm vụ",
    ReturnToPreviousStageAssignee:
      "Giao lại cho người thực thi ở 1 giai đoạn phía trước",
    PleaseEnterTheStageName: "Vui lòng nhập tên giai đoạn",
    PleaseSelectTheTaskAssignmentMethod:
      "Vui lòng chọn cách công việc được giao",
    PleaseSelectAStage: "Vui lòng chọn giai đoạn (bắt buộc)",
    PleaseEnterTheCorrectFormat: "Vui lòng nhập đúng định dạng ví dụ: 12:30",
    ConfirmWorkflowClosure: "Xác nhận đóng luồng công việc",
    AreYouSureYouWantToCloseThisWorkflow:
      "Bạn có chắc chắn muốn đóng luồng công việc này?",
    CurrentStage: "Giai đoạn hiện tại",
    TimeSpent: "Đã sử dụng",
    NextStage: "Giai đoạn kế tiếp",
    TaskInformation: "Thông tin nhiệm vụ",
    MovedToStageAt: "Chuyển giai đoạn lúc",
    StageFollower: "Người theo dõi giai đoạn",
    WorkflowFollower: "Người theo dõi luồng",
    StageProgress: "Tiến trình các giai đoạn",
    WaitingStage: "Giai đoạn chờ đến lượt",
    SkippedStage: "Giai đoạn bị bỏ qua",
    Duration: "Thời lượng",
    TaskMarkedAsFailed: "Nhiệm vụ được đánh dấu là thất bại",
    TaskMovedToTheNextStage: "Nhiệm vụ đã được chuyển sang giai đoạn tiếp theo",
    TaskTransitionFailed: "Nhiệm vụ chuyển tiếp thất bại",
    EnterTheReasonForFailure: "Nhập lý do thất bại",
    PleaseEnterTheReasonForFailure: "Vui lòng nhập lý do thất bại",
    Transition: "Chuyển tiếp",
    MarkAsFailed: "Đánh dấu thất bại",
    StageDueDate: "Thời hạn trong giai đoạn",
    Remaining: "Còn lại",
    NoTasksYet: "Chưa có công việc",
    Done: "Hoàn thành",
    Fail: "Thất bại",
    Cancel: "Hủy",
    TableView: "Dạng bảng",
    GridView: "Dạng lưới",
    AddAStageToTheLeft: "Thêm 1 giai đoạn bên trái",
    AddAStageToTheRight: "Thêm 1 giai đoạn bên phải",
    DeleteStage: "Xoá giai đoạn",
    ConfirmTaskDeletion: "Xác nhận xóa nhiệm vụ",
    ConfirmDeletionOfThisTask: "Bạn có chắc chắn muốn xóa nhiệm vụ này?",
    AreYouSureYouWantToDeleteThisStage:
      "Bạn có chắc chắn muốn xóa giai đoạn này?",
    ConfirmStageDeletion: "Xác nhận xóa giai đoạn",
    OpenInANewTab: "Xem ở trong tab mới",
    BackToPreviouStage: "Quay lại giai đoạn trước đó",
    ReassignToSomeoneElse: "Giao lại cho người khác",
    DeleteTask: "Xóa nhiệm vụ",
    SelectTaskAssignees: "Lựa chọn một người phụ trách nhiệm vụ này",
    PleaseSelectTaskAssignees: "Vui lòng chọn người phụ trách",
    EditDescription: "Chỉnh sửa mô tả nhiệm vụ",
    InProgress: "Đang làm",
    Assign: "Giao",
    NotAssigned: "Chưa được giao",
    TaskAssignedToWhichStage:
      "Công việc được giao cho người thực hiện ở giai đoạn nào?",

    ImmutableDeadline: "Thời hạn không thể điều chỉnh",
    InsertAt: "Chèn vào",
    InsertBeforeDoneStage: "Trước giai đoạn Done",
    AdvancedOptions: "Tuỳ chọn nâng cao",
    AllowExecutorToUpdateNextStageDuration:
      "Cho phép người thực thi cập nhật thời gian cho giai đoạn tiếp theo",
    SkipSunday: "Bỏ qua ngày Chủ nhật",
    RequireFinishPreviousTasks:
      "Yêu cầu hoàn thành các công việc trước khi chuyển giai đoạn",
    NotRequired: "Không bắt buộc",
    Required: "Bắt buộc",
    AllowMembersOrFollowersToAddTasksInThisStage:
      "Cho phép thành viên hoặc người theo dõi nhiệm vụ thêm công việc tại giai đoạn này",
    Price: "Giá",
    Deposit: "Tiền cọc",
    WorkflowIconName: "Icon",
    WorkflowIconDescription: "Icon luồng công việc",
    WorkflowIconPlaceholder: "Chọn icon luồng công việc"
  },
  Comment: {
    Comment: "Bình luận",
    EditComment: "Chỉnh sửa bình luận"
  },
  Chat: {
    GroupNew: "Nhóm chat mới",
    SearchForChatGroup: "Tìm nhóm chat",
    NewChat: "Mới",
    Messages: "Tin nhắn",
    ConversationName: "Tên cuộc trò truyện",
    CreateGroup: "Tạo nhóm",
    NoMessagesYet: "Chưa có tin nhắn nào",
    SeenAt: "Đã xem lúc",
    TypeYourMessage: "Nhập tin nhắn",
    PleaseEnterTheGroupName: "Vui lòng nhập tên nhóm",
    EditConversationName: "Chỉnh sửa tên cuộc trò truyện"
  },
  Summary: {
    Title: "Tổng quan",
    Loading: "Đang tải...",
    Activity: "Hoạt động",
    Notifications: "Thông báo",
    NotificationsLoading: "Đang tải...",
    NotificationsNoMore: "Đã hết thông báo",
    Traffic: "Lượng truy cập",
    CompletionRate: "Tỷ lệ hoàn thành",
    TaskCount: "Số lượng nhiệm vụ",
    SearchPlaceholder: "Tìm kiếm...",
    NoWorkflow: "Không có workflow",
    Cards: {
      TotalTasks: "Tổng số nhiệm vụ",
      CompletedTasks: "Nhiệm vụ hoàn thành",
      FailedTasks: "Nhiệm vụ thất bại",
      InProgressTasks: "Nhiệm vụ đang làm",
      CancelledTasks: "Nhiệm vụ đã hủy"
    },
    Sort: {
      Default: "Sắp xếp",
      TotalDesc: "Tổng (Cao → Thấp)",
      TotalAsc: "Tổng (Thấp → Cao)",
      InProgressDesc: "Đang làm (Cao → Thấp)",
      InProgressAsc: "Đang làm (Thấp → Cao)",
      FailedDesc: "Thất bại (Cao → Thấp)",
      FailedAsc: "Thất bại (Thấp → Cao)",
      CompletedDesc: "Hoàn thành (Cao → Thấp)",
      CompletedAsc: "Hoàn thành (Thấp → Cao)"
    },
    Table: {
      Performer: "Người thực hiện",
      InProgress: "Đang làm",
      Failed: "Thất bại",
      Completed: "Hoàn thành",
      Cancelled: "Hủy"
    }
  },
  User: {
    DoYouWantToChangeYourProfilePicture: "Bạn muốn thay đổi ảnh đại diện?",
    PleaseEnterYourCurrentPassword: "Vui lòng nhập mật khẩu mới",
    PleaseEnterYourNewPassword: "Vui lòng nhập mật khẩu cũ",
    ConfirmUpdate: "Bạn có chắc chắc muốn thay đổi thông tin cá nhân?",
    ChangeIt: "Bạn muốn thay đổi?",
    AccountManagement: "Quản lý tài khoản",
    AccountInformation: "Thông tin tài khoản",
    NoEmployeeIDYet: "Chưa có mã nhân viên",
    ChangePassword: "Đổi mật khẩu",
    Position: "Chức danh",
    DirectManager: "Quản lý trực tiếp",
    NoManagerAssigned: "Chưa có người quản lý",
    PersonalContactInformation: "Thông tin liên hệ",
    EditAccountInformation: "Chỉnh sửa thông tin",
    NoInformationAvailable: "Không có thông tin",
    RemainingLeaveDays: "Remaining leave days",
    Department: "Phòng ban",
    DirectReports: "Nhân viên trực tiếp",
    Address: "Địa chỉ",
    EnterAddress: "Nhập địa chỉ",
    EditInformation: "Chỉnh sửa thông tin cá nhân",
    EditDirectManager: "Chỉnh sửa người quản lý trực tiếp",
    AdminPermissions: "Phân quyền quản trị",
    UpdateAnnuaLeave: "Cập nhật phép năm",

    AccountManagementMemberTitle: "Quản lý tài khoản | Thành viên",
    SearchMembersPlaceholder: "Tìm kiếm thành viên...",
    AddAccount: "Thêm tài khoản",
    CreateNewAccountTitle: "Tạo tài khoản mới",

    LastAndMiddleNameLabel: "Họ và tên đệm",
    EnterLastAndMiddleName: "Nhập họ và tên đệm",
    FirstNameLabel: "Tên",
    EnterFirstName: "Nhập tên",
    UsernameLabel: "Tên đăng nhập",
    EnterUsername: "Nhập username",
    EmailLabel: "Email",
    EnterEmailAddress: "Nhập địa chỉ email",

    AccountType: "Loại tài khoản",
    PleaseSelect: "Vui lòng chọn",
    PleaseSelectAccountType: "Vui lòng chọn loại tài khoản",
    TypeToSearch: "Gõ để tìm",
    EmployeeLabel: "nhân viên",

    PleaseEnterLastAndMiddleName: "Vui lòng nhập họ và tên đệm",
    PleaseEnterFirstName: "Vui lòng nhập tên",
    PleaseEnterUsername: "Vui lòng nhập username",
    InvalidEmailFormat: "Định dạng email không hợp lệ",
    PleaseEnterEmailAddress: "Vui lòng nhập địa chỉ email",

    CreateAccountSuccess: "Tạo tài khoản thành công"
  },
  Department: {
    AccountManagementGroupTitle: "Quản lý tài khoản | Nhóm",

    SearchGroupsPlaceholder: "Tìm kiếm nhóm...",

    CreateUserGroupButton: "Tạo nhóm người dùng",
    CreateUserGroupModalTitle: "Tạo nhóm người dùng",

    GroupNameLabel: "Tên nhóm",
    EnterGroupName: "Tên nhóm",

    UsernameLabel: "Username",
    EnterGroupUsername: "@tennhom",

    GroupAdminLabel: "Quản trị nhóm",
    MembersLabel: "Thành viên",
    MembersNoteCanBeAddedLater: "Thành viên có thể được thêm sau",

    TypeToSearchPlaceholder: "Gõ để tìm",
    AddMembersPlaceholder: "Thêm thành viên",

    SearchNoResultTitleDepartment: "phòng ban",

    EmptyList: "Danh sách trống",

    AdminLabelUppercase: "QUẢN TRỊ VIÊN",
    NoAdminYet: "Chưa có quản trị viên",

    MembersSuffix: "thành viên",
    NoMembersYet: "Chưa có thành viên",

    LoadMore: "Xem thêm",

    PleaseEnterGroupName: "Vui lòng nhập tên nhóm",
    PleaseEnterUsername: "Vui lòng nhập username",
    PleaseSelectGroupAdmin: "Vui lòng chọn người quản trị nhóm",

    // ===== Cho màn chi tiết công ty =====
    CompanyNameLabel: "Tên công ty",
    CompanyNamePlaceholder: "Nhập tên công ty",

    TaxIdentificationNumberLabel: "Mã số thuế",
    TaxIdentificationNumberPlaceholder: "Nhập mã số thuế",

    NumberOfUsersCreatedLabel: "Số lượng user được phép tạo",
    NumberOfUsersCreatedPlaceholder: "Nhập số lượng user được phép tạo",

    ExpirationDateLabel: "Ngày hết hạn",
    ExpirationDatePlaceholder: "Nhấn để chọn ngày",

    ConnectionStringLabel: "Key",
    ConnectionStringPlaceholder: "Key kết nối",

    EditCompanyInfoModalTitle: "Chỉnh sửa thông tin",
    AddMembersModalTitle: "Thêm thành viên",

    DeleteMembersButton: "Xoá thành viên",
    DeleteCompanyButton: "Xoá công ty",

    ConfirmDeleteCompanyTitle: "Bạn muốn xoá?",
    ConfirmDeleteCompanyContent: "Bạn có chắc chắn muốn xoá công ty này?",
    DeleteCompanySuccessMessage: "Xoá công ty thành công",

    PleaseEnterCompanyName: "Vui lòng nhập tên công ty",
    PleaseEnterConnectionString: "Vui lòng nhập connectionString",
    PleaseEnterPhoneNumber: "Vui lòng nhập số điện thoại",
    PleaseEnterTaxIdentificationNumber: "Vui lòng nhập mã số thuế",
    PleaseEnterAddress: "Vui lòng nhập địa chỉ",
    PleaseEnterNumberOfUsersCreated:
      "Vui lòng nhập số lượng user được phép tạo",
    PleaseEnterEmail: "Vui lòng nhập địa chỉ mail",
    InvalidEmailFormat: "Định dạng mail không hợp lệ",
    PleaseSelectMembers: "Vui lòng chọn thành viên",

    EditGroupInfoModalTitle: "Chỉnh sửa thông tin",

    AddMembersButton: "Thêm thành viên",
    DeleteGroupButton: "Xoá nhóm",

    ConfirmDeleteDepartmentTitle: "Bạn muốn xoá?",
    ConfirmDeleteDepartmentContent: "Bạn có chắc chắn muốn xoá nhóm này?",
    DeleteDepartmentSuccessMessage: "Xoá nhóm thành công",

    NoGroupAdminYet: "Chưa có người quản trị",
    EditLabel: "Sửa",
    SearchNewGroupAdminPlaceholder: "Gõ để tìm người quản trị mới",
    AddMultipleMembersInfo: "Có thể thêm nhiều thành viên một lúc"
  },
  UserDetail: {
    EmployeeInfoTitle: "THÔNG TIN NHÂN VIÊN",
    EmailLabel: "Email",
    NoInfo: "Chưa có thông tin",
    DirectManagerLabel: "Quản lý trực tiếp",
    NoManagerYet: "Chưa có người quản lý",

    // Toast & confirm
    ToastUpdateSuccess: "Cập nhật thành công",
    ToastErrorDefault: "Đã xảy ra lỗi",
    ToastDeactivateSuccess: "Tài khoản này đã bị vô hiệu hoá",

    ConfirmDeactivateTitle: "Bạn muốn vô hiệu hoá?",
    ConfirmDeactivateContent:
      "Bạn có chắc chắn muốn vô hiệu hoá tài khoản này?",
    ConfirmDeactivateSubmitText: "Xác nhận",

    // Buttons
    DeactivateAccountButton: "Vô hiệu hoá tài khoản",
    ModalSubmitText: "Cập nhật",
    ModalCancelText: "Huỷ bỏ",

    // Checkboxes / flags
    TimeOffCheckboxLabel: "Tính phép",

    // Basic info
    EmployeeCodeLabel: "Mã nhân viên",
    EmployeeCodePlaceholder: "M000",

    UsernameLabel: "Username",
    UsernamePlaceholder: "Nhập userName",

    LastNameLabel: "Họ và tên đệm",
    LastNamePlaceholder: "Nhập họ và tên",

    FirstNameLabel: "Tên",
    FirstNamePlaceholder: "Tên",

    PositionLabel: "Chức danh",
    PositionPlaceholder: "Nhập chức danh",

    DepartmentLabel: "Phòng ban",
    DepartmentPlaceholder: "Gõ để tìm",

    PhoneNumberLabel: "Số điện thoại",
    PhoneNumberPlaceholder: "Nhập số điện thoại",

    BirthDateLabel: "Ngày sinh",

    AddressLabel: "Địa chỉ",
    AddressPlaceholder: "Nhập địa chỉ",

    // Change password
    NewPasswordLabel: "Mật khẩu mới",
    NewPasswordPlaceholder: "Nhập mật khẩu mới",

    // Change manager
    SelectDirectManagerTitle: "Chọn người quản lý trực tiếp",
    CurrentManagerLabel: "Người quản lý hiện tại",
    NewManagerLabel: "Chọn người quản lý mới",
    SearchManagerPlaceholder: "Gõ để tìm",

    // Roles & permissions
    RoleSelectLabel: "Phân quyền tài khoản",
    RoleSelectPlaceholder: "Vui lòng chọn",

    PermissionSectionTitle: "Cấp quyền sử dụng",
    PermissionSelectAllLabel: "Chọn tất cả",

    // Time off
    AnnualLeaveLabel: "Số phép năm",
    AnnualLeavePlaceholder: "Nhập ngày phép",

    // Validation messages
    PleaseEnterLastName: "Vui lòng nhập họ và tên đệm",
    PleaseEnterFirstName: "Vui lòng nhập tên",
    PleaseEnterUsername: "Vui lòng nhập username",
    PleaseEnterNewPassword: "Vui lòng nhập mật khẩu mới",
    PleaseSelectManager: "Vui lòng chọn người quản lý",
    EmptyList: "Danh sách trống",
    SelectedCount: "Chọn {{count}}",
    FullNameHeader: "HỌ VÀ TÊN",
    AccountHeader: "TÀI KHOẢN",
    InfoHeader: "THÔNG TIN",
    DeleteButtonText: "Xoá",
    NoAnnualLeaveLabel: "Không có",
    DaySuffix: "ngày",
    ConfirmRemoveFromGroupTitle: "Bạn có muốn xoá?",
    ConfirmRemoveFromGroupContent:
      "Bạn có chắc chắn muốn xoá thành viên khỏi nhóm?"
  },
  TimeOff: {
    PageTitle: "Nghỉ phép",
    RequestListTitle: "Danh sách đề xuất",

    CreateRequestButton: "Tạo đề xuất",
    CreateRequestMenuItem: "Tạo đề xuất",
    ExportExcelMenuItem: "Xuất Excel theo tháng",

    TabMyTimeOff: "Phép của tôi",
    TabPending: "Chờ duyệt",
    TabManagerApproved: "Quản lý đã duyệt",
    TabCEOApproved: "Đã được duyệt",
    TabRejected: "Đã từ chối",
    TableHeaderIndex: "#",
    TableHeaderTitle: "Tiêu đề",
    TableHeaderCreator: "Người tạo",
    TableHeaderDate: "Ngày đề xuất",
    TableHeaderStatus: "Trạng thái",

    ToolbarSelectedCount: "{{count}} đề xuất",
    ToolbarApproveAll: "Phê duyệt tất cả",

    EmptyText: "Không có dữ liệu",
    CreateModalTitle: "Tạo yêu cầu nghỉ phép",
    CreateModalSubmit: "Lưu lại",
    CreateModalCancel: "Bỏ qua",
    CreateModalPastDateWarning:
      "[Bắt buộc] Bạn không thể đề xuất những ngày trong quá khứ",

    CreateModalTitleLabel: "Tiêu đề",
    CreateModalTitleHintPrefix: "Theo mẫu:",
    CreateModalTitleHintSample: "ĐƠN XIN NGHỈ PHÉP - HỌ VÀ TÊN - MSNV",
    CreateModalTitlePlaceholder: "Tiêu đề",

    CreateModalTypeLabel: "Loại đề xuất",

    CreateModalDescriptionLabel: "Mô tả đề xuất",
    CreateModalDescriptionPlaceholder: "Mô tả đề xuất",

    CreateModalSessionLabel: "Ca đề xuất",
    CreateModalSelectDatePlaceholder: "Nhấn để chọn ngày",

    CreateModalAddNextDay: "+THÊM NGÀY NỐI TIẾP",

    CreateModalSuccessMessage: "Tạo yêu cầu nghỉ phép thành công",
    TypeAnnualLeaveLess3Days: "Nghỉ phép năm dưới 3 ngày",
    TypeAnnualLeaveMore3Days: "Nghỉ phép năm trên 3 ngày",
    TypeUnpaidLeaveLess3Days: "Nghỉ không lương dưới 3 ngày",
    TypeUnpaidLeaveMore3Days: "Nghỉ không lương trên 3 ngày",
    Validation: {
      TitleRequired: "Vui lòng nhập tiêu đề",
      TypeRequired: "Vui lòng chọn loại đề xuất",
      DescriptionRequired: "Vui lòng nhập lý do",
      InvalidTime: "Thời gian không hợp lệ",
      TimeRequired: "Vui lòng chọn thời gian",
      TimeOffTypeRequired: "Vui lòng chọn loại phép"
    }
  },
  Meeting: {
    MeetingManagement: "Quản lý phòng họp",
    CreateButton: "Đăng ký lịch họp",
    CreateModalTitle: "Đăng ký lịch họp mới",
    CreateModalSubmit: "Đăng ký",
    CreateModalCancel: "Huỷ bỏ",

    TitleLabel: "Tiêu đề",
    TitlePlaceholder: "Tiêu đề",
    DescriptionLabel: "Mô tả",
    DescriptionPlaceholder: "Mô tả",

    RoomLabel: "Phòng họp",
    RoomPlaceholder: "Vui lòng chọn",
    RoomErrorText: "Vui lòng chọn phòng họp",

    StartTimeLabel: "Thời gian bắt đầu",
    EnterStartTimeLabel: "Vui lòng nhập thời gian bắt đầu",
    EndTimeLabel: "Thời gian kết thúc",
    EnterEndTimeLabel: "Vui lòng nhập thời gian kết thúc",

    ParticipantsLabel: "Tham dự",
    ParticipantsPlaceholder: "Gõ tên để chọn người tham dự, ...",
    OtherParticipantsLabel: "Thành phần tham dự khác",
    OtherParticipantsInfo: "Người tham dự khác ngoài công ty",
    OtherParticipantsPlaceholder: "Khách hàng, ...",

    FilterSectionTitle: "Phân loại",
    MyBookingsTitle: "Đăng ký của tôi",

    ToastCreateSuccess: "Đăng ký lịch thành công",

    ValidationTitleRequired: "Vui lòng nhập tiêu đề",
    ValidationDescriptionRequired: "Vui lòng nhập mô tả",
    ValidationRoomRequired: "Vui lòng chọn phòng họp",
    ValidationParticipantsRequired: "Vui lòng chọn người tham dự",
    EventDetail: {
      TooltipDeleteSchedule: "Xoá lịch họp",
      TooltipEditSchedule: "Chỉnh sửa thông tin",

      ModalEditTitle: "Chỉnh sửa lịch đăng ký",
      ModalSubmit: "Cập nhật",
      ModalClose: "Huỷ bỏ",

      FieldStatus: "Trạng thái",
      FieldDateTime: "Ngày - Giờ",
      FieldLocation: "Địa điểm",
      FieldHost: "Người chủ trì",
      FieldParticipants: "Tham dự",
      FieldOtherParticipants: "Tham dự khác",

      PlaceholderCancelReason: "Nhập lý do",

      Form: {
        Title: "Tiêu đề",
        TitlePlaceholder: "Tiêu đề",
        Description: "Mô tả",
        DescriptionPlaceholder: "Mô tả",
        Room: "Phòng họp",
        RoomPlaceholder: "Vui lòng chọn",
        RoomRequiredMessage: "Vui lòng chọn phòng họp",
        StartTime: "Thời gian bắt đầu",
        EndTime: "Thời gian kết thúc",
        Participants: "Tham dự",
        ParticipantsPlaceholder: "Gõ tên để chọn người tham dự",
        OtherParticipants: "Thành phần tham dự khác",
        OtherParticipantsInfo: "Người tham dự khác ngoài công ty",
        OtherParticipantsPlaceholder: "Khách hàng, ..."
      },

      Validation: {
        TitleRequired: "Vui lòng nhập tiêu đề",
        DescriptionRequired: "Vui lòng nhập mô tả",
        StartDateRequired: "Vui lòng nhập thời gian bắt đầu",
        ParticipantsRequired: "Vui lòng chọn người tham dự"
      },

      Actions: {
        Approve: "Duyệt",
        Reject: "Từ chối",
        Complete: "Kết thúc",
        CancelRegister: "Huỷ đăng ký",
        Cancel: "Huỷ bỏ",
        ConfirmCancel: "Xác nhận huỷ",
        Confirm: "Xác nhận"
      },

      Confirm: {
        ApproveTitle: "Bạn muốn phê duyệt đăng ký này?",
        ApproveContent: "Bạn chắc chắn muốn phê duyệt đăng ký này?",
        RejectTitle: "Bạn từ chối đăng ký này?",
        RejectContentLine1: "Bạn muốn từ chối đăng ký này?",
        RejectContentLine2: "Đăng ký này sẽ bị xoá sau khi xác nhận",
        CompleteTitle: "Bạn muốn kết thúc cuộc họp này?",
        CompleteContent:
          "Bạn sẽ không thể tiếp tục sử dụng phòng họp sau khi xác nhận",
        RequestCancelTitle: "Bạn muốn yêu cầu huỷ?",
        RequestCancelContent: "Bạn chắc chắn muốn yêu cầu huỷ đăng ký này?",
        ApproveCancelTitle: "Bạn muốn phê duyệt yêu cầu huỷ?",
        ApproveCancelContent:
          "Bạn chắc chắn muốn phê duyệt yêu cầu huỷ đăng ký này?",
        DeleteTitle: "Bạn muốn xoá đăng ký này?",
        DeleteContent: "Đăng ký này sẽ bị xoá sau khi xác nhận",
        SubmitText: "Xác nhận"
      },

      Messages: {
        UpdateSuccess: "Cập nhật thành công",
        UpdateError: "Đã có lỗi xảy ra",
        DeleteSuccess: "Đăng ký đã bị xoá",
        GenericError: "Đã xảy ra lỗi"
      }
    }
  },
  MeetingStatus: {
    Pending: "Chờ duyệt",
    Confirmed: "Đã duyệt",
    Cancel: "Đã huỷ",
    WaitCancel: "Chờ huỷ",
    Completed: "Đã kết thúc",
    Unknown: "Không xác định"
  },
  TimeOffStatus: {
    ManagerApprove: "Quản lí đã duyệt",
    CEOApprove: "Đã phê duyệt",
    Pending: "Đang chờ duyệt",
    NotApprove: "Đã từ chối",
    Cancelled: "Đã huỷ bỏ",
    TeamLeaderApprove: "Tổ trưởng đã duyệt"
  },
  TimeOffDetail: {
    StatusLabel: "Trạng thái",
    StatusUpdateSuccess: "Trạng thái đã được cập nhật",
    StatusUpdateErrorDefault: "Đã xảy ra lỗi khi cập nhật trạng thái",

    DeleteSuccess: "Đề xuất đã được xoá",
    DeleteErrorDefault: "Đã xảy ra lỗi khi xoá đề xuất",

    ApproveButton: "Chấp thuận",
    RejectButton: "Từ chối",
    DeleteButton: "Xoá đơn",

    MainInfoSectionTitle: "THÔNG TIN CHÍNH",
    MainInfoIdPrefix: "ID:",

    CreatedByLabel: "Tạo bởi",
    SalaryAffectLabel: "Ghi nhận công",
    SalaryAffectYes: "Có tính công",
    SalaryAffectNo: "Không tính công",
    ContentLabel: "Nội dung",

    TimeOffSectionTitle: "CA XIN NGHỈ"
  },
  Docs: {
    SearchPlaceholder: "Tìm kiếm văn bản...",
    Unread: "Chưa xem",
    LoadMore: "Hiển thị văn bản cũ hơn",
    EmptyTitle: "Không có nội dung hiển thị",
    DocumentType: {
      Title: "Loại văn bản",
      AddNew: "Thêm mới",
      ActionActivate: "Kích hoạt",
      ActionEdit: "Chỉnh sửa",
      ActionDelete: "Xoá",
      ConfirmDeleteTitle: "Bạn có chắc chắc muốn xoá?",
      ConfirmDeleteContent: "Bạn không thể khôi phục sau khi xác nhận",
      ConfirmToggleTitle: "Bạn có chắc chắc muốn thay đổi?",
      ConfirmToggleContent: "Trạng thái sẽ được thay đổi sau khi xác nhận",
      ConfirmButton: "Xác nhận",
      ErrorCommon: "Đã xảy ra lỗi",
      SuccessUpdate: "Cập nhật thành công",
      DeactivatePrefix: "Huỷ"
    },
    DocumentForm: {
      Document: "Văn bản",
      TitleCreate: "TẠO VĂN BẢN MỚI",
      TitleEdit: "CHỈNH SỬA VĂN BẢN",
      LabelNumberIdentifier: "Số, kí hiệu",
      PlaceholderNumberIdentifier: "Số, kí hiệu",
      LabelTitle: "Tiêu đề",
      PlaceholderTitle: "Tiêu đề thông báo",
      LabelIssueDate: "Ngày ban hành",
      LabelExpireDate: "Ngày hết hạn",
      LabelContent: "Nội dung",
      PlaceholderContent: "Nhập nội dung...",
      ErrorTitleRequired: "Vui lòng nhập tiêu đề",
      ErrorContentRequired: "Vui lòng nhập nội dung",
      ErrorIssueDateRequired: "Vui lòng chọn ngày ban hành",
      LabelReceiver: "Nơi nhận",
      PlaceholderReceiver: "Gõ tên để chọn người nhận, ...",
      LabelSendAllCompany: "Gửi toàn công ty",
      LabelDocumentType: "Loại văn bản",
      PlaceholderSelect: "Vui lòng chọn",
      ErrorDocumentTypeRequired: "Vui lòng chọn loại văn bản",
      LabelStatus: "Trạng thái",
      PlaceholderSelectStatus: "Vui lòng chọn",
      LabelTags: "Từ khoá",
      PlaceholderTags: "Từ khoá",
      AttachmentTitle: "Tài liệu đính kèm",
      AttachmentInfo: "Đính kèm tối đa 10 tài liệu",
      AttachmentTooltipDelete: "Xoá tài liệu",
      AttachmentSelectButton: "Chọn tài liệu đính kèm",
      DeleteFilesSuccess: "Cập nhật thành công",
      DeleteFilesError: "Đã xảy ra lỗi, vui lòng thử lại",
      ButtonCancel: "Huỷ",
      ButtonUpdate: "Cập nhật",
      ButtonCreate: "Tạo mới"
    },
    DocumentTypeForm: {
      TitleEdit: "Chỉnh sửa",
      TitleCreate: "Tạo loại văn bản",
      LabelName: "Tên loại văn bản",
      PlaceholderName: "Nhập tên loại văn bản",
      LabelActive: "Kích hoạt",
      Processing: "Đang xử lý..",
      ButtonCancel: "Huỷ bỏ",
      ButtonUpdate: "Cập nhật",
      ButtonCreate: "Tạo mới"
    },
    Admin: {
      ButtonDocumentType: "Loại văn bản",
      ButtonCreateDocument: "Tạo văn bản mới",
      TableHeaderDocument: "CÔNG VĂN",
      TableHeaderStatus: "TRẠNG THÁI",
      TableHeaderType: "LOẠI",
      TableHeaderTime: "THỜI GIAN",
      LabelIssueDate: "Ngày ban hành",
      LabelExpireDate: "Ngày hết hạn",
      NoInfo: "Không có thông tin",
      TooltipEdit: "Chỉnh sửa thông tin",
      TooltipViewDetail: "Xem chi tiết",
      TooltipDelete: "Xoá văn bản",
      ConfirmDeleteTitle: "Bạn có chắc chắn muốn xoá văn bản này?",
      ConfirmDeleteContent: "Bạn sẽ không thể hoàn tác sau khi xác nhận",
      ConfirmDeleteSubmit: "Xác nhận",
      UploadError: "Upload file xảy ra lỗi, vui lòng thử lại",
      EmptyTitle: "Chưa có công văn nào được tạo",
      ErrorNoDocTypeNoPermission:
        "Bạn không thể tạo văn bản khi chưa có loại văn bản, nếu không có quyền thao tác vui lòng liên hệ admin để được cấp quyền",
      LoadingData: "Đang tải dữ liệu..",
      UpdateSuccess: "Cập nhật thành công",
      CreateSuccess: "Thêm mới thành công",
      CommonError: "Đã xảy ra lỗi, vui lòng thử lại"
    },
    Status: {
      PendingRelease: "Chờ ban hành",
      Released: "Đã ban hành",
      Revocation: "Đã thu hồi",
      Unknown: "Không xác định"
    },
    DownloadFileTooltip: "Tải xuống tài liệu",
    IssueDate: "Ngày phát hành:",
    ExpirationDate: "Ngày hết hạn:",
    NoExpirationInfo: "Không có thông tin",
    AttachmentsTitle: "TỆP ĐÍNH KÈM"
  },
  Rules: {
    Title: "Nội quy",
    Buttons: {
      EditRules: "Chỉnh sửa nội quy",
      CancelChanges: "Huỷ bỏ thay đổi",
      UpdateRules: "Cập nhật nội quy"
    },
    Placeholder: {
      EnterRules: "Vui lòng nhập nội quy..."
    },
    Empty: {
      NoRules: "Chưa có thông tin",
      NoData: "Không có thông tin"
    },
    Messages: {
      UpdateSuccess: "Cập nhật thành công",
      UpdateError: "Đã có lỗi xảy ra"
    }
  },
  TimeOffType: {
    Title: "Loại nghỉ phép",
    Tabs: {
      Types: "Loại nghỉ phép",
      MailCC: "Mail CC"
    },
    Loading: {
      Data: "Đang tải dữ liệu..."
    },
    Table: {
      Columns: {
        Name: "Tên loại nghỉ phép",
        Calculation: "Cách tính",
        Actions: "Thao tác"
      },
      Operation: {
        Minus: "Tính phép năm",
        NotOperation: "Không tính phép năm"
      }
    },
    Buttons: {
      CreateType: "Thêm loại nghỉ phép",
      Delete: "Xoá",
      Edit: "Chỉnh sửa",
      AddMail: "Thêm mail"
    },
    MailCC: {
      DefaultLabel: "Người được cc mặc định:",
      EmptyList: "Danh sách trống"
    },
    Modal: {
      TitleEdit: "Chỉnh sửa loại nghỉ phép",
      TitleCreate: "Thêm mới loại nghỉ phép",
      Submit: "Xác nhận",
      Close: "Huỷ bỏ",
      Fields: {
        NameLabel: "Tên loại nghỉ phép",
        NamePlaceholder: "Tên loại nghỉ phép",
        OperationLabel: "Tính phép năm",
        OperationYes: "Có",
        OperationNo: "Không"
      },
      Validation: {
        NameRequired: "Vui lòng nhập tên loại nghỉ phép",
        OperationRequired: "Vui lòng chọn loại"
      }
    }
  },
  MeetingRoom: {
    Approve: {
      Sidebar: {
        Title: "DANH SÁCH PHÒNG HỌP",
        TooltipDeleteRoom: "Nhấn giữ để xoá",
        ButtonCreateRoom: "Thêm phòng họp"
      },
      TodaySchedule: {
        Title: "LỊCH HỌP HÔM NAY"
      },
      Tabs: {
        Pending: "Chờ phê duyệt",
        WaitCancel: "Chờ xác nhận huỷ",
        Confirmed: "Đã phê duyệt",
        Completed: "Đã kết thúc"
      },
      List: {
        MonthTitle: "Tháng",
        NoRoomInformation: "Không có thông tin",
        NoRegistrantData: "Không có dữ liệu"
      },
      CreateRoomModal: {
        Title: "Tạo phòng họp",
        Submit: "Tạo mới",
        Fields: {
          NameLabel: "Tên phòng họp",
          NamePlaceholder: "Tên phòng họp",
          DescriptionLabel: "Mô tả",
          DescriptionPlaceholder: "Mô tả",
          LocationLabel: "Vị trí",
          LocationPlaceholder: "Vị trí"
        },
        Validation: {
          NameRequired: "Vui lòng nhập tên phòng",
          LocationRequired: "Vui lòng nhập vị trí",
          DescriptionRequired: "Vui lòng nhập mô tả"
        }
      },
      Messages: {
        CreateSuccess: "Tạo phòng thành công",
        RoomDeleted: "Phòng họp đã bị xoá",
        RegisterDeleted: "Đăng ký đã bị xoá",
        UpdateSuccess: "Cập nhật thành công",
        GenericError: "Đã xảy ra lỗi"
      },
      Confirm: {
        DeleteRoomTitle: "Bạn muốn xoá phòng họp này?",
        DeleteRoomContent: "Bạn chắc chắn muốn xoá phòng họp này",
        DeleteRoomSubmit: "Xác nhận",

        RejectTitle: "Bạn từ chối đăng ký này?",
        RejectContentLine1: "Bạn muốn từ chối đăng ký này?",
        RejectContentLine2: "Đăng ký này sẽ bị xoá sau khi xác nhận",
        RejectSubmit: "Xác nhận",

        ApproveTitle: "Bạn muốn duyệt đăng ký?",
        ApproveContent: "Bạn chắc chắn muốn duyệt đăng ký này?",
        ApproveSubmit: "Phê duyệt",

        CancelRequestTitle: "Bạn muốn duyệt yêu cầu huỷ?",
        CancelRequestContent:
          "Bạn chắc chắn muốn duyệt yêu cầu huỷ đăng ký này?",
        CancelRequestSubmit: "Xác nhận",

        CompleteTitle: "Bạn muốn kết thúc cuộc họp này?",
        CompleteContent:
          "Bạn sẽ không thể tiếp tục sử dụng phòng họp sau khi xác nhận",
        CompleteSubmit: "Xác nhận"
      },
      Buttons: {
        Reject: "Từ chối",
        Approve: "Phê duyệt",
        ConfirmCancel: "Xác nhận",
        Complete: "Kết thúc"
      }
    }
  },
  Header: {
    Profile: {
      Account: "Tài khoản",
      Support: "Hỗ trợ"
    },
    Logout: {
      ConfirmTitle: "Bạn có muốn đăng xuất",
      ConfirmContent: "Bạn có chắc chắc muốn đăng xuất khỏi tài khoản này?",
      Button: "Đăng xuất"
    },
    Notifications: {
      Title: "Thông báo ({{count}})",
      ReadAllTooltip: "Đọc tất cả thông báo",
      ReadAllConfirmTitle: "Bạn muốn đọc hết tất cả thông báo?",
      ReadAllConfirmContent: "Bạn chắc chắn muốn đọc hết các thông báo này?",
      Empty: "Chưa có thông báo nào",
      LoadMore: "Hiển thị thông báo cũ hơn"
    }
  },
  Account: {
    Nav: {
      Personal: "Cá nhân",
      Member: "Nhân viên",
      Group: "Nhóm",
      Company: "Công ty",
      Home: "Trang chủ"
    }
  },
  Gads: {
    Button: {
      Update: "Cập nhật GAds"
    },
    Modal: {
      Title: "Cập nhật GAds"
    },
    Field: {
      GoogleAds: "Google Ads"
    },
    Validate: {
      IframeRequired: "Vui lòng nhập iframe Google Ads"
    }
  },
  Gcsl: {
    Button: {
      Update: "Cập nhật Console"
    },
    Modal: {
      Title: "Cập nhật Console"
    },
    Field: {
      GoogleAds: "Google Console"
    },
    Validate: {
      IframeRequired: "Vui lòng nhập iframe Google Console"
    }
  },
  Booking: {
    Calendar: {
      NoEventsText: "Không có dữ liệu"
    },
    MobileList: {
      Today: "Hôm nay",
      Meeting: "lịch họp"
    },
    Validation: {
      RoomNameRequired: "Vui lòng nhập tên phòng",
      LocationRequired: "Vui lòng nhập vị trí",
      DescriptionRequired: "Vui lòng nhập mô tả"
    },
    Messages: {
      ConfirmChangeTitle: "Bạn muốn thay đổi thời gian thành",
      ConfirmStart: "Bắt đầu",
      ConfirmEnd: "Kết thúc",
      ConfirmButtonText: "Xác nhận",
      UpdateSuccess: "Cập nhật thành công!",
      UpdateError: "Đã xảy ra lỗi"
    }
  },
  TaskUpdateModal: {
    UpdateTaskSuccess: "Cập nhật nhiệm vụ thành công",
    ModalTitle: "Cập nhật nhiệm vụ",
    ButtonUpdate: "Cập nhật",
    ButtonCancel: "Huỷ bỏ",
    LabelTaskName: "Tên nhiệm vụ",
    PlaceholderTaskName: "Tên nhiệm vụ",
    LabelAssignTo: "Giao cho",
    PlaceholderAssignTo: "Sử dụng @ để tag thành viên nhận nhiệm vụ",
    LabelDescription: "Mô tả nhiệm vụ",
    InfoDescription: "Mô tả ngắn về nhiệm vụ",
    PlaceholderDescription: "Mô tả ngắn về nhiệm vụ",
    LabelComment: "Bình luận",
    PlaceholderComment: "Viết thảo luận của bạn",
    LabelAttachments: "Tài liệu đính kèm",
    InfoAttachments: "Đính kèm tối đa 10 tài liệu",
    TitleAttachments: "Tài liệu đính kèm",
    EditTitleAttachments: "Chỉnh sửa tài liệu đính kèm",
    ValidateTaskName: "Vui lòng nhập tên nhiệm vụ",
    ValidateAssign: "Vui lòng chọn người nhận nhiệm vụ"
  },
  TimeOffMailCC: {
    ModalTitle: "Cập nhật cc nghỉ phép mặc định",
    SubmitText: "Xác nhận",
    CancelText: "Huỷ bỏ",
    LabelCC: "Người được cc mặc định",
    InfoMax: "Tối đa 10",
    PlaceholderEmail: "Nhập địa chỉ mail",
    AddMailButton: "+Thêm Mail",
    ErrorAtLeastOneCC: "Vui lòng thêm ít nhất 1 người được cc mặc định",
    DefaultSuccessMessage: "Cập nhật thành công"
  },
  DeleteTimeOffType: {
    ModalTitle: "Xác nhận xoá loại nghỉ phép",
    SubmitText: "Xác nhận",
    CancelText: "Huỷ bỏ",
    ConfirmDeleteLabel: "Xác nhận xoá",
    SuccessMessage: "Xoá thành công"
  },
  Payroll: {
    Title: "Bảng lương",
    FileName: "File name",
    Email: "Email",
    Attachments: "File đính kèm",
    SendPayroll: "Gửi bảng lương",
    CreatedDate: "Ngày gửi",
    Modal: {
      TitleCreate: "File đính kèm bản lương",
      ButtonSend: "Gửi"
    }
  },
  OpenAiChat: {
    Greeting: "Xin chào 👋 Tôi có thể giúp gì cho bạn?",
    Placeholder: "Nhập tin nhắn... (Enter để gửi, Shift + Enter để xuống dòng)",
    Uploading: "Đang tải lên...",
    UploadSuccess: "Tải lên thành công.",
    UploadError: "Tải lên thất bại.",
    NoFiles: "Chưa có file nào được tải lên.",
    DocsTitle: "Tài liệu phân tích",
    DocsDesc: "Chọn file docx để tải lên và cho AI đọc.",
    UploadBtn: "Tải lên",
    DeleteSuccess: "Xóa tệp thành công",
    AskHint:
      "Gợi ý: Gõ câu hỏi, chọn file rồi bấm Tải lên để AI đọc tài liệu và trả lời theo nội dung đó.",
    WaitingResponse: "⏳ Đang chờ trả lời...",
    ErrorResponse: "❌ Lỗi khi nhận phản hồi từ AI",
    InvalidFile: "Chỉ hỗ trợ file .doc hoặc .docx"
  }
};

export default VI;
